import axios from "axios";

export const getDataTableTransaksiJurnal = async (
  searchText = null,
  offset = 0,
  limit = 0,
  sortingCol = 0,
  sortingMode = "DESC"
) => {
  if (searchText) {
    return await axios.get(
      `${window._HOST}akuntan/transaksiJurnal/dataTable?search-text=${searchText}&offset=${offset}&limit=${limit}&sorting-col=${sortingCol}&sorting-mode=${sortingMode}`,
      { withCredentials: true }
    );
  } else {
    return await axios.get(
      `${window._HOST}akuntan/transaksiJurnal/dataTable?offset=${offset}&limit=${limit}&sorting-col=${sortingCol}&sorting-mode=${sortingMode}`,
      { withCredentials: true }
    );
  }
};

export const insertNewTransaksiJurnal = async (formData) => {
  return await axios.post(`${window._HOST}akuntan/transaksiJurnal/`, formData, {
    withCredentials: true,
  });
};

export const deleteTransaksiJurnal = async (id_transaksi_jurnal) => {
  return await axios.delete(
    `${window._HOST}akuntan/transaksiJurnal/${id_transaksi_jurnal}`,
    { withCredentials: true }
  );
};
